<template>
    <van-row class="footer" justify="space-around">
        <van-col span="4" class="footer_item">
            <div v-if="tabList[0].display" class="footer_item_container" @click="goToPath(tabList[0].redirectUrl, 0)">
                <img v-if="activeFooter == 0" :src="tabList[0].active_url" alt="">
                <img v-else :src="tabList[0].default_url" alt="">
                <div class="footerText" :style="{ color: activeFooter == 0 ? '#ffda2f' : '' }">{{ $t(tabList[0].title)
                    }}</div>
            </div>
        </van-col>
        <van-col span="4" class="footer_item">
            <div v-if="tabList[1].display" class="footer_item_container" @click="goToPath(tabList[1].redirectUrl, 1)">
                <img v-if="activeFooter == 1" :src="tabList[1].active_url" alt="">
                <img v-else :src="tabList[1].default_url" alt="">
                <div class="footerText" :style="{ color: activeFooter == 1 ? '#ffda2f' : '' }">{{ $t(tabList[1].title)
                    }}</div>
            </div>
        </van-col>
        <van-col span="4" class="footer_button_item">
            <div v-if="tabList[2].display" class="footer_item_container" @click="goToPath('/sd-carteira', 2)">
                <img :src="tabList[2].default_url" alt="">
                <div class="footerText" :style="{ color: activeFooter == 2 ? '#ffda2f' : '' }">{{
                    $t(tabList[2].title) }}</div>
            </div>
        </van-col>
        <van-col span="4" class="footer_item">
            <div v-if="tabList[3].display" class="footer_item_container" @click="goToPath(tabList[3].redirectUrl, 3)">
                <div v-if="promoCount > 0" class="redPoint">{{ promoCount }}</div>
                <img v-if="activeFooter == 3" :src="tabList[3].active_url" alt="">
                <img v-else :src="tabList[3].default_url" alt="">
                <div class="footerText" :style="{ color: activeFooter == 3 ? '#ffda2f' : '' }">{{ $t(tabList[3].title)
                    }}</div>
            </div>
        </van-col>
        <van-col span="4" class="footer_item">
            <div v-if="tabList[4].display" class="footer_item_container" @click="goToPath(tabList[4].redirectUrl, 4)">
                <img v-if="activeFooter == 4" :src="tabList[4].active_url" alt="">
                <img v-else :src="tabList[4].default_url" alt="">
                <div class="footerText" :style="{ color: activeFooter == 4 ? '#ffda2f' : '' }">{{ $t(tabList[4].title)
                    }}</div>
            </div>
        </van-col>
    </van-row>
    <PromotionPopup ref="promotionRef" @handleClose="handlePopupClose" @openAgent="goToPath('/agent', 2)"
        @openPWA="openPWAPopup" />
    <AgentPopup ref="agentPopupRef" @handleCloseagent="handlePopupClose" @openPromotion="() => promotionRef.open()" />
    <RegisterLoginPopup ref="registerRef" />
    <CarteiraView ref="walletPopupRef" @handleClose="handlePopupClose" @reopenBackgroundRechargePopup="reopenBackgroundRechargePopup" />
</template>

<script setup lang="ts">
import { playClickSound } from '@/utils/media';
import AgentPopup from '@/view/agent/agentPopup.vue';
import PromotionPopup from '@/view/promotion/promotionPopup.vue';
import RegisterLoginPopup from '@/view/loginRegister/registerLoginPopup.vue';
import { ref, defineEmits, defineExpose, defineProps, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';
import { goToPathFunc, goToPathFuncThem2, handlePopupCloseFunc, TabItem } from '@/view/components/supportFunction';
import CarteiraView from '@/view/carteiraView/carteiraView.vue';
import { watch } from 'vue';


const router = useRouter();
const route = useRoute()

const props = defineProps<{
    itemData: {
        tabs: TabItem[]
    }
}>()
const userStore = useUserStore()
const tabList = computed(() => props.itemData.tabs);
const promotionRef = ref();
const activeFooter = ref(0);
const promoCount = computed(() => userStore.totalMsgListCount);
const agentPopupRef = ref();
const walletPopupRef = ref()
const registerRef = ref();
const emits = defineEmits(['goToProfile', 'profileClose', 'openPWA', 'reopenBackgroundRechargePopup'])

const goToPath = (path: string, indexValue: number) => {
    goToPathFuncThem2(path, indexValue, activeFooter, router, promotionRef, walletPopupRef, agentPopupRef, registerRef, emits, playClickSound)
}

const handlePopupClose = () => {
    handlePopupCloseFunc(activeFooter, promotionRef)
}
const goToAgent = () => {
    playClickSound()
    agentPopupRef.value.open()
    promotionRef.value.close()
    emits('profileClose')
    activeFooter.value = 1
}
const setProfileActiveFooter = () => {
    activeFooter.value = 4
}
const handleHistoryOpenPopup = () => {
    const indexNo: any = localStorage.getItem('footerPopupOpen')
    if (indexNo == 4) {
        goToPath(tabList.value[4].redirectUrl, 4)
    } else if (indexNo == 3) {
        goToPath(tabList.value[3].redirectUrl, 3)
    }else if (indexNo == 2) {
        goToPath('/sd-carteira', 2)
    }
}

const openPWAPopup = () => {
    emits("openPWA")
}
watch(activeFooter, (val) => {
     userStore.setIsInHome(val)
})
const reopenBackgroundRechargePopup = () => {
    emits('reopenBackgroundRechargePopup')
}
onMounted(() => {
    // tabList.value = props.itemData.tabs
    handleHistoryOpenPopup()
    if (route.query.value) {
        goToPath('/sd-carteira', 2)
    }
})
defineExpose({
    setProfileActiveFooter,
    goToAgent,
    goToPath
})
</script>
<style scoped>
.footer {
    bottom: 0;
    z-index: 1999;
    width: 100vw;
    /* height: 45px; */
    position: fixed;
    left: 0;
    right: 0;
    display: flex;
    background-image: url('@/assets/themetwo/tableBar_bg.png');
    background-size: cover;
    background-repeat: no-repeat;
    padding: 0;
}

.footer_item_container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #ffffff90;
}

.footer_item img {
    width: 50%;
    padding-top: 2px;
}

.footerText {
    padding-top: 5px;
}

.footer_button_item {
    justify-content: center;
    text-align: center;
}

.footer_button_item img {
    margin-top: -55%;
    width: 110%;
}

.redPoint {
    position: absolute;
    border-radius: 30px;
    background: #FF0000;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    font-size: 8.5px;
    padding: 3px;
    font-weight: bold;
    margin: 5px 0 0px 40px;
    width: 10px;
    height: 10px;
}

@media (min-width:450px) {
    .footer {
        width: 100%;
    }
}

@media (min-width: 1440px) {
    .footer {
        width: 30rem;
    }
}

@media (min-width: 1920px) {
    .footer {
        width: 35rem;
    }
}
</style>